export const disConnectedModalSx = {
  mainBox: {
    padding: '0px 0px 24px 0px'
  },
  desc: {
    fontFamily: 'Inter',
    fontSize: 'var(--font-size-16)',
    fontWeight: 500,
    lineHeight: 'var(--line-height-24)',
    textAlign: 'left',
    color: 'var(--color-text-tertiary)'
  },
  btnSx: {
    marginTop: '16px',
    alignSelf: 'flex-end'
  },
  span: {
    textDecoration: 'underline',
    color: 'var(--color-primary)',
    fontWeight: 600,
    cursor: 'pointer'
  },
  checkBoxTextSx: {
    fontFamily: 'Inter',
    fontSize: 'var(--font-size-16)',
    fontWeight: 700,
    lineHeight: 'var(--line-height-24)',
    textAlign: 'center',
    color: 'var(--color-text-muted)'
  }
};
